import { PriceInfoDto, CreatePriceDto } from '@sr/dto';
import { mediaApi } from '../api-slice';
import { MEDIA_BASE_URL, PRICES_BASE_URL } from 'shared/api/api';

type GetQuery = {
    mediaId: number,
    searchParams?: URLSearchParams,
    options?: {
        isActive?: boolean | null;
    }
}
type Optional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

const api = mediaApi.injectEndpoints({
  endpoints: (builder) => ({
    addMediaPrice: builder.mutation<PriceInfoDto, Optional<CreatePriceDto, 'mainFile'>>({
      query: (data) => ({
        url: `${PRICES_BASE_URL}/upload`,
        method: 'POST',
        body: data
      })
    }),
    getMediaPrices: builder.query<PriceInfoDto[], GetQuery>({
      query: ({ mediaId, searchParams, options }) => {
        const queryParams = new URLSearchParams(searchParams);
        if (options?.isActive !== undefined && options.isActive !== null) {
          queryParams.append('isActive', String(options.isActive));
        }
        return {
          url: `${MEDIA_BASE_URL}/${mediaId}/prices${queryParams?.toString() ? `?${queryParams.toString()}` : ''}`,
          method: 'GET'
        };
      }
    }),
    deactivatePrice: builder.mutation<void, number>({
      query: (id) => ({
        url: `${PRICES_BASE_URL}/${id}/deactive`,
        method: 'POST'
      })
    }),
    deletePrice: builder.mutation<void, number>({
      query: (id) => ({
        url: `${PRICES_BASE_URL}/${id}`,
        method: 'DELETE'
      })
    })
  })
});

export const mediaPriceApi = api.enhanceEndpoints({
  addTagTypes: ['MEDIA_PRICES'],
  endpoints: {
    addMediaPrice: {
      invalidatesTags: ['MEDIA_PRICES', { type: 'MediaList', id: 'LIST' }, { type: 'MediaCities', id: 'LIST' }]
    },
    deactivatePrice: {
      invalidatesTags: ['MEDIA_PRICES', { type: 'MediaList', id: 'LIST' }]
    },
    deletePrice: {
      invalidatesTags: ['MEDIA_PRICES']
    },
    getMediaPrices:  {
      providesTags: ['MEDIA_PRICES']
    }
  }
});
